"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideMenuButton = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var SideMenuButton = function SideMenuButton(_ref) {
  var image = _ref.image,
      altText = _ref.altText,
      label = _ref.label;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [image && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: image,
      alt: altText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: label
    })]
  });
};

exports.SideMenuButton = SideMenuButton;